import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {Partner} from 'src/types/partner'

interface PartnerState {
  partners: Partner[]; // Change from a single object to an array
}

const initialState: PartnerState = {
  partners: [], // Default to an empty array
};

const partnerSlice = createSlice({
  name: 'partner',
  initialState,
  reducers: {
    // Add a single partner to the array
    addPartner(state, action: PayloadAction<Partner>) {
      state.partners.push(action.payload);
    },
    // Set the entire array of partners
    setPartners(state, action: PayloadAction<Partner[]>) {
      state.partners = action.payload;
    },
    // Remove a partner by ID
    removePartner(state, action: PayloadAction<string>) {
      state.partners = state.partners.filter((partner) => partner.id !== action.payload);
    },
    // Clear all partners
    clearPartners(state) {
      state.partners = [];
    },
  },
});

export const { addPartner, setPartners, removePartner, clearPartners } = partnerSlice.actions;
export default partnerSlice.reducer;